import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatAllSmallCaps = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	fill: "none",
	viewBox: "0 0 20 21",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m3.75 16.25 2.75-7.5 2.75 7.5M4.75 14h3.5m5.502-1.75c.998 0 1.748-.5 1.748-1.75 0-1-.75-1.75-1.748-1.75H12c-.25 0-.25 0-.25.25v3.25m2.002 0h.712c1.286 0 1.786 1 1.786 2s-.5 2-1.786 2H12c-.25 0-.25 0-.25-.25v-3.75m2.002 0H11.75"
	})]
});
const ForwardRef = forwardRef(SvgFormatAllSmallCaps);
export { ForwardRef as ReactComponent };
